'use client';

import Image from 'next/image';

import Lines from '@public/images/lines.svg';

import styles from './HowItWorks.module.scss';

const steps = [
  {
    title: (
      <>
        Start with the <span className={styles.strong}>Personal Assessment</span>
      </>
    ),
    description:
      'Begin by completing a tailored evaluation designed to measure your existing knowledge, technical background and readiness for quantum learning. This step determines your optimal entry point into the program.',
  },
  {
    title: 'Follow your personalized learning path',
    description:
      'Based on your Assessment  Performance Report, it will be recommended to you to choose from the following plans:',
    bullets: [
      'Start with Quantum Basic',
      'Advance to Quantum Professional',
      'Enhance with Quantum Academia',
    ],
  },
  {
    title: 'Engage with Real World applications',
    description: (
      <>
        You will work with <span className={styles.strong}>DYNEX</span>, a cutting-edge neuromorphic
        quantum computing platform architecture, and dive into your practical use cases.
      </>
    ),
  },
  {
    title: 'Capstone Projects',
    description: (
      <>
        These are available under <span className={styles.strong}>Quantum Academia</span> plan. It
        challenges you to solve a complex real world quantum problem, using{' '}
        <span className={styles.strong}>DYNEX</span> technology.
      </>
    ),
  },
  {
    title: 'Earn your certification',
    description:
      'By Successful completion of the program plan, you will receive a Certificate of Completion.',
  },
];

export default function HowItWorks() {
  return (
    <div id="how-it-works" className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>HOW IT WORKS</div>

        <div className={styles.subtitle}>
          No matter your starting point, Applied Quantum Computing with Dynex meets you where you
          are, and takes you where the future is going.
        </div>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.steps}>
          <Image src={Lines} className={styles.lines} alt="Lines" draggable={false} />

          {steps.map((step, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={styles.step}>
              <div className={styles.step_title}>{step.title}</div>

              <div className={styles.step_description}>{step.description}</div>

              {step.bullets && (
                <div className={styles.step_bullets}>
                  {step.bullets.map((bullet, bulletIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={bulletIndex} className={styles.step_bullets_li}>
                      <div className={styles.step_bullets_mark}>
                        <div />
                        <div />
                        <div />
                      </div>

                      <div>{bullet}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
